import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%"
  },
  label: {
    minHeight: "25.6px",
    color: theme.palette.primaryGrey,
    ...theme.typography.h6,
  }
}));
